import React from "react";
import { Icons, IconButton, Tooltip } from "@curves/ui-base";

const AddTemporaryActionBar = props => {
	const { getResult: getResultProps = () => {}, dialogRef, refresh: refreshProps } = props;

	const handleClick = () => {
		const targetData = getResultProps();
		if (dialogRef && dialogRef.current && targetData.list.length !== 0) dialogRef.current.openNonMemberAddTemporary(targetData, refreshProps);
	};

	return (
		<Tooltip title={"加入到暫存名單"}>
			<IconButton onClick={handleClick}>
				<Icons.FolderPlus />
			</IconButton>
		</Tooltip>
	);
};

export default AddTemporaryActionBar;
